import { render, staticRenderFns } from "./Account-settings.vue?vue&type=template&id=337a8936&lang=html"
import script from "./Account-settings.vue?vue&type=script&lang=js"
export * from "./Account-settings.vue?vue&type=script&lang=js"
import style0 from "./Account-settings.vue?vue&type=style&index=0&id=337a8936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports